<template>
    <div class="antialiased text-[var(--dark-gray)] background">
        <AppBanner title="API Award"
            message="Unified.to Real-Time Unified API wins Best Business Software API at the 2026 API Awards"
            ctaText="Read more"
            ctaUrl="https://unified.to/blog/unified_wins_best_business_software_api_at_the_2026_api_awards"
            :expiration-date="new Date('2026-11-30')" />

        <AppBanner title="2025 Growth"
            message="Unified Hits Major Growth Milestones with 6.5x usage & 4.5x revenue growth" ctaText="Read more"
            ctaUrl="/blog/unified_hits_major_growth_milestone_as_api_usage_surges_550percent_in_2025"
            :expiration-date="new Date('2026-06-30')" />

        <AppBanner title="BLACK FRIDAY SALE" message="50% off for 3 months - use code: BLACKFRIDAYSALE25"
            ctaText="Upgrade TODAY" ctaUrl="https://app.unified.to/settings/billing"
            :expiration-date="new Date('2025-11-30')" />

        <!-- <AppBanner title="Case Study"
            message="Mycroft's AI-driven Security and Compliance platform launches integrations in 15 minutes."
            ctaText="Read more"
            ctaUrl="https://unified.to/blog/mycroft_ships_new_integrations_in_15_minutes?utm_source=blog&utm_medium=banner&utm_campaign=mycroft_casestudy"
            :expiration-date="new Date('2025-03-15')" /> -->

        <!-- <AppBanner title="Case Study"
            message="Merchkit accelerates sales by eliminating e-commerce integration uncertainty, launching in just 2 weeks."
            ctaText="Read more"
            ctaUrl="https://unified.to/blog/how_merchkit_accelerates_sales_by_removing_integration_uncertainty?utm_source=blog&utm_medium=banner&utm_campaign=merchkit_casestudy"
            :expiration-date="new Date('2025-05-15')" /> -->

        <AppBanner title="Case Study"
            message="How Interstellar Labs Scaled Their Agent Platform to Enterprise with Unified.to"
            ctaText="Read more"
            ctaUrl="https://unified.to/blog/how_interstellar_labs_scaled_their_agent_platform_to_enterprise_with_unified"
            :expiration-date="new Date('2025-11-01')" />


        <PageHeader
            class="bg-[#0d0d0d] lg:flex lg:justify-between lg:items-center h-20 gap-4 px-5 lg:px-5 lg:py-3  w-full z-20 lg:top-0" />

        <!-- <div class="py-24">
            <div class="hidden lg:inline-block bg-[var(--primary-red)] p-8">LG</div>
            <div class="hidden md:inline-block bg-[var(--primary-red)] p-8">MD</div>
            <div class="hidden sm:inline-block bg-[var(--primary-red)] p-8">SM</div>
            <div class="hidden xs:inline-block bg-[var(--primary-red)] p-8">XS</div>
        </div> -->

        <div class="lg:mt-20">
            <PageActions />
            <main>
                <NuxtPage dark />
            </main>
        </div>

        <PageFooter class="p-3 sm:px-28 sm:py-8" />
    </div>
</template>

<script lang="ts">
export default {
    data() {
        return {
            showBanner: true,
        };
    },
    mounted() {
        // (window as any).Intercom?.('boot', {
        //     api_base: 'https://api-iam.intercom.io',
        //     app_id: 'riumpsew',
        // });

        console.log(`
/***
 *       __  __      _ _____          __    __
 *      / / / /___  (_) __(_)__  ____/ /   / / ____
 *     / / / / __ \\/ / /_/ / _ \\/ __  /   / __/ __ \\
 *    / /_/ / / / / / __/ /  __/ /_/ /_  / /_/ /_/ /
 *    \\____/_/ /_/_/_/ /_/\\___/\\____/(_)/__/ \\____/
 *
 */
`);
    },
};
</script>

<style>
.hero {
    /* border-radius: 12px; */
    /* margin-left: 0; */
    /* margin-right: 0; */
    /* margin-bottom: 20px; */
    /* margin-top: 10px; */
    /* background-color: #2b2c58; */
    /* background: linear-gradient(90deg, #2b2c58, #5355aa); */
    /* color: white; */
    /* padding-top: 60px; */
    /* padding-bottom:60px; */
    /* padding-left: 30%;
    padding-right: 30%; */
    align-items: stretch;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* --tw-shadow: 0 10px 15px -3px #0000001a, 0 4px 6px -4px #0000001a; */
    /* --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color); */
    /* box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow); */
    /* box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow); */
}

/* Thid does not work if I place this in main.css */
.colour {
    /* Starts at --primary-blue: blue-800 (rgb(30 64 175)) was 2.15:1 on --background, below WCAG AA. */
    background: linear-gradient(90deg, var(--primary-blue) 16.98%, var(--secondary-blue) 93.17%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-background-clip: text;
    color: #0000;
    /* text-fill-color: transparent; */
    -webkit-text-fill-color: transparent;
    /* padding-left: 0.25rem; */
    /* padding-right: 0.25rem; */
}




@media (max-width: 640px) {
    .hero {
        padding-right: 20px;
        padding-left: 20px;
        /* margin-left: 14px; */
        /* margin-right: 14px; */
    }

    /* .hero h1 { */
    /* font-size: 300%; */
    /* } */
}
</style>